import { trackError, type TelemetryProperties } from '@if/core/telemetry'

export function reportErrorToConsole(error: unknown) {
  console.error(error)
}

/**
 * Report a caught error. Context belongs in `properties` — it rides on the
 * exception itself rather than arriving as a separate item to correlate by hand.
 */
export function reportErrorToServer(error: unknown, properties?: TelemetryProperties) {
  reportErrorToConsole(error)
  trackError(error, properties)
}
